import React, { Component } from 'react';
import moment from 'moment';
import { getItemInfo } from 'components/ItemFetch';
import { User as UserComponent } from '@lyearn-team/frontend-components';
import themeConfig from '@lyearn-team/theme-config';
import User from '../../../../helper/currentUser';

const user = new User();

class AssignmentDetails extends Component {
  rerender = () => {
    this.setState({});
  };

  renderDueDate = (assignedBy, dueDate) => {
    if (assignedBy.pid === user.id() || dueDate === '-1' || dueDate === -1 || !dueDate) {
      return null;
    }
    return [
      <div key={0} className="detailHeader">
        Due Date
      </div>,
      <div key={1} className="detailContent">
        {moment(dueDate).format('DD MMM YYYY')}
      </div>
    ];
  };

  render() {
    // console.log('Course: ', this.props.course);
    const {
      assignInfo: { assignedBy, dueDate, assignedDate }
    } = this.props.course;
    const name = getItemInfo('users', assignedBy.pid, 'name', this.rerender, '...');
    const picture = getItemInfo(
      'users',
      assignedBy.pid,
      'picture',
      this.rerender,
      'https://dndw32r4edmw5.cloudfront.net/assets/avatar.jpg'
    );
    return (
      <div className="courseDetailContainer assignmentDetailsContainer">
        {this.renderDueDate(assignedBy, dueDate)}
        <div className="detailHeader">Assigned By</div>
        <div className="detailContent">
          <UserComponent
            style={{ color: themeConfig.color.grey1 }}
            picture={picture}
            name={name}
            size="medium"
            hideEmail={true}
          />
        </div>
        <div className="detailHeader">Assigned On</div>
        <div className="detailContent">{moment(assignedDate).format('DD MMM YYYY')}</div>
      </div>
    );
  }
}

export default AssignmentDetails;
